import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es7.string.pad-start";
import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import bf1 from "@/assets/bf1.png";
import bf2 from "@/assets/bf2.png";
import bf3 from "@/assets/bf3.png";
import { get_effective_router, get_effective_router_data } from "@/api/chuku";
import { get_merchant_all, get_now_lnglat, trajectory_did_list, iotdatalastget, trajectory_did_detail } from "@/api/jingxiaoshang";
import { getMonthToCurrent } from "@/libs/util";
export default {
  // mixins: [packageTableMixins],
  data: function data() {
    return {
      bf1: bf1,
      bf2: bf2,
      bf3: bf3,
      // 地图实例
      map: null,
      cruise: null,
      //巡航器实例
      cruiseIndex: -1,
      // 当前播放轨迹下标
      pathSimplifierIns: null,
      //轨迹实例
      isPlay: false,
      //是否播放
      isComplete: true,
      //是否完成
      pointSum: 0,
      //播放器总数
      sliderValue: 0,
      //播放器当前数
      startPoint: 0,
      //下次播放轨迹从当前值开始
      marksIndex: {},
      //每段路的起止坐标
      allowedDates: [],
      // 轨迹坐标
      pathList: [],
      options: {},
      speedValue: 2,
      // 当前播放速度下标
      // 速度列表，可自定义配置
      speedList: [{
        value: 0.5,
        speed: 100
      }, {
        value: 1,
        speed: 200
      }, {
        value: 2,
        speed: 400
      }, {
        value: 4,
        speed: 1600
      }, {
        value: 8,
        speed: 12800
      }, {
        value: 16,
        speed: 25600
      }],
      value_jindu: 0,
      is_show: false,
      trajectoryDataList: [],
      tableDataList: [],
      deviceinfo: {
        device_name: "",
        did: "",
        soc: "",
        zdy: "",
        zdl: "",
        yjbh: "",
        ejbh: "",
        sjbh: "",
        gzzt: ""
      },
      percent: 20,
      setInt: null,
      trackAni: null,
      merchantData: [],
      keyword: null,
      location: null,
      formModel: {
        lng: 0,
        lat: 0
      },
      position: {
        lng: 116.297611,
        lat: 40.047363
      },
      center: {
        lng: 116.297611,
        lat: 40.047363
      },
      zoom: 3,
      value1: "1",
      shoplist: [{
        shop_name: "111",
        lng: 103,
        lat: 30
      }, {
        shop_name: "222",
        lng: 104,
        lat: 33
      }],
      statusData: [{
        value: -1,
        name: "全部"
      }, {
        value: 2,
        name: "在线"
      }, {
        value: 1,
        name: "离线"
      }],
      form_filter: {
        merchant_code: "",
        did: ""
      },
      reqBase: {
        date: "",
        did: "",
        cate: 2
      },
      //cate 默认2拉取行程
      reqBase2: {
        start: 0,
        end: 0,
        did: "",
        cate: 1
      },
      //cate 默认1拉取点
      switchValue: true,
      other_point: []
    };
  },
  components: {},
  methods: {
    format: function format(val) {
      // alert(this.pathList.length)
      var jindu = Math.round(val / this.pathList.length * 100);
      return "进度: " + jindu + "%";
    },
    // 加载地图
    loadMap: function loadMap() {
      var _this = this;

      var count_gj = this.pathList.length - 1;
      this.map = new AMap.Map("container", {
        zoom: 16,
        //级别
        center: [this.pathList[0][0], this.pathList[0][1]] //中心点坐标 默认在杭州

      }); // 创建一个 Icon

      var startIcon = new AMap.Icon({
        // 图标尺寸
        size: new AMap.Size(25, 34),
        // 图标的取图地址
        image: "https://a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png",
        // 图标所用图片大小
        imageSize: new AMap.Size(135, 40),
        // 图标取图偏移量
        imageOffset: new AMap.Pixel(-9, -3)
      }); // 将 icon 传入 marker

      var startMarker = new AMap.Marker({
        map: this.map,
        position: new AMap.LngLat(this.pathList[0][0], this.pathList[0][1]),
        icon: startIcon,
        offset: new AMap.Pixel(-13, -30)
      }); // 创建一个 icon

      var endIcon = new AMap.Icon({
        size: new AMap.Size(25, 34),
        image: "https://a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png",
        imageSize: new AMap.Size(135, 40),
        imageOffset: new AMap.Pixel(-95, -3)
      }); // 将 icon 传入 marker

      var endMarker = new AMap.Marker({
        map: this.map,
        position: new AMap.LngLat(this.pathList[count_gj][0], this.pathList[count_gj][1]),
        icon: endIcon,
        offset: new AMap.Pixel(-13, -30)
      });
      return new Promise(function (reslove, reject) {
        //加载PathSimplifier，loadUI的路径参数为模块名中 'ui/' 之后的部分
        new AMapUI.load(["ui/misc/PathSimplifier"], function (PathSimplifier) {
          if (!PathSimplifier.supportCanvas) {
            alert("当前环境不支持 Canvas！");
            return;
          }

          if (_this.pathList.length) {
            //启动页面
            _this.initPage(PathSimplifier);
          }
        });
        reslove();
      });
    },
    initPage: function initPage(PathSimplifier) {
      var _this2 = this;

      var content = PathSimplifier.Render.Canvas.getImageContent("https://a.amap.com/jsapi_demos/static/demo-center-v2/car.png", function () {
        //图片加载成功，重新绘制一次
        _this2.pathSimplifierIns.renderLater();
      }, function onerror(e) {
        this.$message({
          type: "error",
          message: "图片加载失败！"
        });
      });
      this.pathSimplifierIns = new PathSimplifier({
        zIndex: 100,
        autoSetFitView: true,
        map: this.map,
        getPath: function getPath(pathData, pathIndex) {
          return pathData.path;
        },
        renderOptions: {
          //轨迹线的样式
          getPathStyle: function getPathStyle(pathItem, zoom) {
            return {
              pathLineStyle: {
                strokeStyle: "#00E000",
                lineWidth: 6,
                dirArrowStyle: true
              }
            };
          },
          pathNavigatorStyle: {
            pathLinePassedStyle: {
              strokeStyle: "#00F",
              lineWidth: 6,
              dirArrowStyle: true
            },
            lineWidth: 6,
            initRotateDegree: 0,
            width: 40,
            height: 70,
            autoRotate: true,
            content: content
          }
        }
      });
      this.cruiseInit();
    },
    // 巡航器初始化
    cruiseInit: function cruiseInit() {
      var _this3 = this;

      var pathSimplifierIns = [{
        path: this.pathList,
        color: "#00E000"
      }];
      this.pathSimplifierIns.setData(pathSimplifierIns);
      this.pointSum = 0;
      var marksIndex = {};
      pathSimplifierIns.forEach(function (item, index) {
        _this3.pointSum += item.path.length;
        marksIndex[index] = [0, _this3.pointSum];
      });
      this.marksIndex = marksIndex;
      this.cruiseStop(); //this.cruiseStart()
      //   this.cruiseStart()
    },
    // 创建一个巡航器
    createdCruise: function createdCruise(index) {
      this.cruiseIndex++; // 判断是否传入index

      var cruiseIndex;

      if (index != undefined) {
        cruiseIndex = index;
        this.cruiseIndex = index;
      } else {
        cruiseIndex = this.cruiseIndex;
      }

      var cruise = this.pathSimplifierIns.createPathNavigator(cruiseIndex, //关联第index条轨迹
      {
        loop: false,
        //循环播放
        speed: this.speedList[this.speedValue].speed //速度

      });

      if (this.cruise) {
        // 清空走过的路线
        this.cruise.destroy();
        this.cruise = null;
      }

      return cruise;
    },
    // 开始播放
    cruiseStart: function cruiseStart() {
      var _this4 = this;

      this.isPlay = true;

      if (this.cruise && !this.cruise.isCursorAtPathEnd() && !this.cruise.isCursorAtPathStart() && !this.isComplete) {
        // 路段未开始并且没有结束的时候 暂停恢复动画 并且动画没有完成的时候
        this.cruise.resume();
        return;
      }

      this.isComplete = false;

      if (this.cruiseIndex == 0) {
        this.cruiseStop();
        return;
      }

      this.cruise = this.createdCruise(); // 判断是否传入初始坐标

      if (this.startPoint) {
        this.cruise.start(this.startPoint);
        this.startPoint = 0;
      } else {
        this.cruise.start();
      }

      this.cruise.on("move", function (e) {
        var idx = _this4.cruise.cursor.idx;
        var _this4$pathList$idx = _this4.pathList[idx],
            address = _this4$pathList$idx.address,
            gpsTime = _this4$pathList$idx.gpsTime,
            speed = _this4$pathList$idx.speed;
        var trackAddress = {
          address: address,
          gpsTime: gpsTime,
          speed: speed
        };

        _this4.$emit("changeData", "trackAddress", trackAddress);

        var _this4$marksIndex$_th = _slicedToArray(_this4.marksIndex[_this4.cruiseIndex], 2),
            min = _this4$marksIndex$_th[0],
            max = _this4$marksIndex$_th[1];

        _this4.sliderValue = idx + min;
      }); // 巡航完成事触发

      this.cruise.on("pause", function () {
        if (_this4.cruise && _this4.cruise.isCursorAtPathEnd()) {
          _this4.cruiseStart();
        }
      });
    },
    // 暂停播放
    cruisePause: function cruisePause() {
      this.cruise.pause();
      this.isPlay = false;
    },
    // 停止
    cruiseStop: function cruiseStop() {
      if (this.cruise) {
        // 清空走过的路线
        this.cruise.destroy();
      } // 停止播放


      this.isPlay = false;
      this.isComplete = true;
      this.cruiseIndex = -1; // 为重新播放准备

      this.cruise = this.createdCruise();
      this.cruiseIndex = -1;
      this.sliderValue = 0;
    },
    speedChange: function speedChange() {
      if (this.speedValue == this.speedList.length - 1) {
        this.speedValue = 0;
      } else {
        this.speedValue++;
      }

      this.cruise.setSpeed(this.speedList[this.speedValue].speed);
    },
    slider_change: function slider_change(val) {
      //alert(val)
      this.mapinit(this.other_point, val);
    },
    movingInfo: function movingInfo(info, count_gj) {
      var index = info.index,
          progress = info.progress;
      console.log("index", index);
      console.log("count_gj", count_gj);
      console.log("grogress", progress);
      var index_xh = index + 1;
      this.value_jindu = 100 / count_gj * index_xh; //alert(this.value_indu)
      //  console.log("progress",progress)
    },
    startAnimation: function startAnimation() {
      window.startAnimation(); //this.setInt = setInterval(this.add, 50);
    },
    add: function add() {// let jindu = 100 / 168;
      // //console.log("jindu",jindu)
      // this.value_jindu += jindu;
    },
    pauseAnimation: function pauseAnimation() {
      window.pauseAnimation();
    },
    resumeAnimation: function resumeAnimation() {
      window.resumeAnimation();
    },
    stopAnimation: function stopAnimation() {
      window.stopAnimation();
    },
    click_trajectory: function click_trajectory(ii) {
      var _this5 = this;

      for (var i = 0; i < this.trajectoryDataList.length; i++) {
        if (ii == i) {
          this.trajectoryDataList[i].class = "gj_box1 check_box";
        } else {
          this.trajectoryDataList[i].class = "gj_box1";
        }
      } //拉取其他点


      var q = this.$route.query;

      if (q.did) {
        this.reqBase2.did = q.did;
        console.log("asdf11223", this.form_filter.did);
      } else {
        console.log("asdf112233", this.form_filter.did);
        this.reqBase2.did = this.form_filter.did;
      } //拉取轨迹


      this.tableLoading = true;
      this.reqBase2.cate = 1;
      this.reqBase2.start = this.trajectoryDataList[ii].start_time_str;
      this.reqBase2.end = this.trajectoryDataList[ii].end_time_str;
      console.log("asdf112233", this.reqBase2);
      trajectory_did_detail(_objectSpread({}, this.reqBase2)).then(function (res) {
        if (res.result === 0) {
          _this5.other_point = res.body;
          var path = [];

          for (var i = 0; i < _this5.other_point.length; i++) {
            path.push([_this5.other_point[i].lng, _this5.other_point[i].lat]);
          }

          _this5.pathList = path; //this.mapinit(this.other_point,-1);

          _this5.loadMap();
        } else {}
      });
    },
    //获取历史最新时间2025/8/7
    newGetLsDate: function newGetLsDate(did) {
      var _this6 = this;

      get_effective_router({
        did: did
      }).then(function (res) {
        _this6.allowedDates = res.body.date_info || [];
        _this6.options = {
          disabledDate: function disabledDate(date) {
            var year = date.getFullYear();
            var month = String(date.getMonth() + 1).padStart(2, "0");
            var day = String(date.getDate()).padStart(2, "0");
            var formattedDate = "".concat(year, "-").concat(month, "-").concat(day);
            return !_this6.allowedDates.some(function (entry) {
              return entry.date === formattedDate;
            });
          }
        };

        if (_this6.allowedDates) {
          _this6.reqBase.start_time1 = _this6.allowedDates[0].date;

          _this6.start_time1_change(_this6.allowedDates[0].date);
        }
      });
    },
    downloadClick: function downloadClick(name) {
      var _this7 = this;

      // console.log(123)
      // console.log(name)
      // debugger
      if (name === "console") {
        var routeData = this.$router.push({
          path: "/jingxiaoshang",
          query: {
            home: 1
          }
        });
        window.open(routeData.href, "_self"); //this.$router.push("/jingxiaoshang")
      } else if (name === "logout") {
        this.$store.dispatch("handleLogOut").then(function (res) {
          if (res.result === 0) {
            _this7.$router.push({
              name: "login"
            });
          }
        });
      }
    },
    clickdid: function clickdid(did, i, i2) {
      var _this8 = this;

      this.reqBase.start_time1 = "";
      this.trajectoryDataList = [];
      console.log('diddid', did);
      this.deviceinfo.device_name = did;
      this.deviceinfo.did = did;

      for (var m = 0; m < this.tableDataList.length; m++) {
        for (var n = 0; n < this.tableDataList[m].didlist.length; n++) {
          if (m == i && n == i2) {
            this.tableDataList[m].didlist[n].class = "did_list did_check";
          } else {
            this.tableDataList[m].didlist[n].class = "did_list";
          }
        }
      }

      console.log(this.tableDataList);
      get_now_lnglat({
        did: did
      }).then(function (res) {
        if (res.result === 0) {
          _this8.mapinit_first(res);
        } else {}
      });
      this.newGetLsDate(did);
      this.form_filter.did = did;
    },
    start_time1_change: function start_time1_change(val) {
      var _this9 = this;

      this.reqBase.date = val;

      if (this.deviceinfo.did) {
        this.reqBase.did = this.deviceinfo.did;
      } else {
        this.reqBase.did = this.form_filter.did;
      } // console.log("asdf", this.reqBase,this.form_filter.did,this.deviceinfo.did);
      //拉取轨迹


      this.tableLoading = true;
      trajectory_did_detail(_objectSpread({}, this.reqBase)).then(function (res) {
        _this9.tableLoading = false;

        if (res.result === 0) {
          _this9.trajectoryDataList = res.body.list || [];
        } else {
          _this9.$Message.error(res.errorMsg);
        }
      });
    },
    search: function search() {
      var _this10 = this;

      //this.is_show = false
      this.trajectoryDataList = [];
      this.reqBase.date = "";
      this.reqBase.start_time1 = "";
      console.log("start_time1", this.reqBase.start_time1);
      this.tableLoading = true;
      trajectory_did_list(_objectSpread({}, this.form_filter)).then(function (res) {
        _this10.tableLoading = false;
        _this10.tableDataList = [];

        if (res.result === 0) {
          _this10.tableDataList = res.body.list || [];

          _this10.mapinit_first();
        } else {
          _this10.tableDataList = [];

          _this10.$Message.error(res.errorMsg);
        }
      });
      console.log("newGetLsDate", this.form_filter.did);
      this.newGetLsDate(this.form_filter.did);
    },
    mapinit_first: function mapinit_first(didinfo) {
      //查询当前位置
      //创建地图
      if (didinfo) {
        var map = new AMap.Map("container", {
          zoom: 11,
          center: [didinfo.body.lng, didinfo.body.lat] // 初始化地图中心点

        });
        var marker = new AMap.Marker({
          map: map,
          position: [didinfo.body.lng, didinfo.body.lat],
          label: {
            offset: new AMap.Pixel(2, 2),
            //修改label相对于maker的位置
            content: "设备当前位置"
          }
        });
        marker.setLabel({
          direction: "right",
          offset: new AMap.Pixel(10, 0),
          //设置文本标注偏移量
          content: "<div class='info'>时间：" + didinfo.body.time + "</div><div class='info2'>" + didinfo.body.did + "</div><div class='info3'>详细地址：" + didinfo.body.addr + "</div><div class='info4'>经度：" + didinfo.body.lng + "</div><div class='info5'>纬度：" + didinfo.body.lat + "</div>" //设置文本标注内容

        });
      } else {
        this.map = new AMap.Map("container", {
          zoom: 10 //级别

        });
      }

      AMapUI.load(["ui/misc/PathSimplifier", "lib/$"], function (PathSimplifier, $) {
        if (!PathSimplifier.supportCanvas) {
          alert("当前环境不支持 Canvas！");
          return;
        }
      });
    },
    init: function init() {
      this.getMerchantData();
      var q = this.$route.query;
      this.form_filter.did = q.did;
      this.deviceinfo.did = q.did; //alert(this.form_filter.did);

      this.search();
    },
    reset: function reset() {
      this.form_filter = {
        status: -1,
        merchant_code: [],
        did: null
      };
    },
    checkTree: function checkTree(arr) {
      for (var i in arr) {
        if (arr[i].shop_name) {
          arr[i].value = arr[i].merchant_code;
          arr[i].label = arr[i].shop_name;
          arr[i].title = arr[i].shop_name;
        } else if (arr[i].shop_name) {
          arr[i].title = arr[i].shop_name;
        }

        if (arr[i].children_shop && arr[i].children_shop.length > 0) {
          var _arr$i$children;

          (_arr$i$children = arr[i].children).push.apply(_arr$i$children, _toConsumableArray(arr[i].children_shop));
        }

        if (arr[i].children && arr[i].children.length > 0) {
          this.checkTree(arr[i].children);
        }
      }
    },
    getMerchantData: function getMerchantData() {
      var _this11 = this;

      // debugger
      this.merchantData.splice(0);
      get_merchant_all().then(function (res) {
        if (res.result === 0) {
          console.log(data);
          var data = res.body;

          _this11.checkTree(data); // console.log('a',data)


          _this11.merchantData = data;
        }
      });
    }
  },
  mounted: function mounted() {
    this.init();
  },
  watch: {
    sliderValue: function sliderValue(val) {
      // 正在播放禁止拖拽播放器
      if (!this.cruise || this.isPlay) return;
      this.cruise.moveToPoint(val);
      this.startPoint = val;
      this.pathSimplifierIns.render();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.pathSimplifierIns) this.pathSimplifierIns.clearPathNavigators();
    if (this.pathSimplifierIns) this.pathSimplifierIns.setData([]);
    if (this.cruise) this.cruise.destroy();
    if (this.map) this.map.destroy();
  },
  created: function created() {
    var _this12 = this;

    // this.getPageSizeToStorage();
    get_effective_router({
      did: this.$route.query.did
    }).then(function (res) {
      _this12.allowedDates = res.body.date_info || [];
      console.log("this.allowedDates", _this12.allowedDates);
      _this12.options = {
        disabledDate: function disabledDate(date) {
          var year = date.getFullYear();
          var month = String(date.getMonth() + 1).padStart(2, "0");
          var day = String(date.getDate()).padStart(2, "0");
          var formattedDate = "".concat(year, "-").concat(month, "-").concat(day);
          return !_this12.allowedDates.some(function (entry) {
            return entry.date === formattedDate;
          });
        }
      };
      console.log("this.allowedDates1", _this12.allowedDates);

      if (_this12.$route.query.time) {
        _this12.reqBase.start_time1 = _this12.$route.query.time;

        _this12.start_time1_change(_this12.$route.query.time);
      }
    });
  }
};